export interface CoachingComment {
  authorAlias: string;
  commentID: string;
  timestamp: string;
  comment: string;
  receiverAlias: string;
}

export interface CommentThread {
  commentThreadType: string;
  commentThreadParticipants: string[];
  comments: CoachingComment[];
}

export interface CoachingCommentsData {
  coachingID?: string;
  noteID: string;
  commentThreads: CommentThread[];
}

export enum CommentThreadType {
  CSA_TM = 'CSA_TM',
  TM_OM1 = 'TM_OM1',
}

export enum UserRole {
  CSA = 'CSA',
  TM = 'TM',
  OM1 = 'OM1',
}

export const DEFAULT_COACHING_COMMENT_DATA: CoachingCommentsData = {
  coachingID: '',
  noteID: '',
  commentThreads: [],
};

export interface AddCoachingCommentResponse {
  commentID?: string;
  error?: string;
}
